import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import NormalBtn from '../common/button/NormalBtn';
import { useState } from 'react';
import Modal from 'react-modal';
import MySettingPwPopup, { MySettingModalStyles } from '../common/popup/MySettingPwPopup';
import NormalPopupOneBtn, { NomalPopupOneBtnStyles } from '../common/popup/NormalPopupOneBtn';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";

const MySettingInfoTableBlock = styled.table`

    border-top: 2px solid #111;
    border-bottom: 1px solid #ccc;

    th {
        padding: 13px 5px 14px;
        font-size: 14px;
        text-align: center;
    }

    td {
        line-height: 1.5;
        position: relative;
        padding: 20px;
        border-top: 1px solid #ccc;
        vertical-align: middle;
        font-size: 15px;
        ${isMobileOnly?`
        padding: 20px 2vw;   
        `:`
        padding: 20px;
        `};
      }

      td.border_bottom {
        border-bottom: 1px solid #ccc;
      }

      td.border_right {
        border-right: 1px solid #ccc;
      }

      td.border_black {
        border-bottom: 1px solid #111;
      }

      td.border_none {
        border-top: none;
      }

      td.border_t-none {
        border-top: none;
      }

      td.padding_none {
        padding: 6px 0;
      }

      td.thumb_none {
        padding-left: 120px;
      }

      b {
        font-weight: 400;
      }

      .mint {
        background-color: rgba(0, 217, 184, 0.1);
      }

      .gray {
        background-color: #f4f4f4;
      }

      .input-box .text-input:disabled {
        color: #999;
        background-color: #e7e7e7;
      }
`;


const MySettingInfoTable = () => {

  const [openModal, setOpenModal] = useState(false);

  // Redux Store에서 저장된 값을 가져옴
  var { id } = useSelector(
    ({ userReducer }) => ({
      id: userReducer.id
    })
  );

  const onCloseModal = () => {
    setOpenModal(false);
  }

  const handleChangePasswd = () => {
    setOpenModal(true);
  }

  const onClosePwPopup = () => {
    setOpenModal(false);
  }

  return (
    <div>
      {isMobileOnly ?
      <MySettingInfoTableBlock style = {{width: '100%'}}>
        <colgroup>
          <col width="30%" />
          <col width="30%" />
          <col width="10%" />
          <col width="30%" />
        </colgroup>
        <tbody>
          <tr>
            <td className="gray">이메일 아이디</td>
            <td colSpan="3">
              <b><span>{id}</span></b>
            </td>
          </tr>
          <tr>
            <td className="gray">비밀번호</td>
            <td colSpan="3">
              <NormalBtn
                minWidth="150px"
                width="150px"
                lineHeight="40px"
                height="40px" borderRadius="30px"
                fontSize="16px" fontWeight="400"
                marginBottom="0px" marginTop="0px" float="none"
                text="비밀번호 변경"
                onClick={handleChangePasswd} />
            </td>
          </tr>
        </tbody>
      </MySettingInfoTableBlock>
      :
      <MySettingInfoTableBlock>
        <colgroup>
          <col width="180px;" />
          <col width="410px;" />
          <col width="180px;" />
          <col width="410px;" />
        </colgroup>
        <tbody>
          <tr>
            <td className="gray">이메일 아이디</td>
            <td colSpan="3">
              <b><span>{id}</span></b>
            </td>
          </tr>
          <tr>
            <td className="gray">비밀번호</td>
            <td colSpan="3">
              <NormalBtn
                minWidth="150px"
                width="150px"
                lineHeight="40px"
                height="40px" borderRadius="30px"
                fontSize="16px" fontWeight="400"
                marginBottom="0px" marginTop="0px" float="none"
                text="비밀번호 변경"
                onClick={handleChangePasswd} />
            </td>
          </tr>
        </tbody>
      </MySettingInfoTableBlock>
      }

      <Modal
        isOpen={openModal}
        onRequestClose={onCloseModal}
        style={MySettingModalStyles}
        onAfterOpen={() => document.body.style.overflow = 'hidden'}
        onAfterClose={() => document.body.removeAttribute('style')}>
        <MySettingPwPopup isIconShow={true}
          text="비밀번호 변경"
          txtBtn="비밀번호 변경하기" onClickIcon={onClosePwPopup} />
      </Modal>
    </div>

  );
};

export default MySettingInfoTable;
